/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Recipe_YieldsInputs */

const en_recipe_yields = /** @type {(inputs: Recipe_YieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Yields`)
};

const de_recipe_yields = /** @type {(inputs: Recipe_YieldsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ergibt`)
};

/**
* | output |
* | --- |
* | "Yields" |
*
* @param {Recipe_YieldsInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const recipe_yields = /** @type {((inputs?: Recipe_YieldsInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Recipe_YieldsInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_recipe_yields(inputs)
	return en_recipe_yields(inputs)
});